/**
 * Product Swiper Media Gallery Initialization JS
 * Handles slider, thumbnail pagination, and theme-editor compatibility.
 */

window.initProductSwiperGallery = function(wrapper) {
  if (!wrapper) return;

  // Clean up existing instances if already initialized
  if (wrapper.mainSwiper) {
    try { wrapper.mainSwiper.destroy(true, true); } catch(e){}
  }
  if (wrapper.thumbsSwiper) {
    try { wrapper.thumbsSwiper.destroy(true, true); } catch(e){}
  }

  const mainEl = wrapper.querySelector('.product-swiper-main');
  const thumbsEl = wrapper.querySelector('.product-swiper-thumbs');

  if (!mainEl) return;

  // Read settings from data attributes
  const loop = mainEl.dataset.loop === 'true';
  const autoplay = mainEl.dataset.autoplay === 'true';
  const autoplayDelay = parseInt(mainEl.dataset.autoplayDelay, 10) || 5000;
  const effect = mainEl.dataset.effect || 'slide';
  const speed = parseInt(mainEl.dataset.speed, 10) || 500;
  const spaceBetween = parseInt(mainEl.dataset.spaceBetween, 10) || 0;

  const thumbsEnabled = thumbsEl && thumbsEl.dataset.thumbsEnabled === 'true';
  const thumbsSpaceBetween = thumbsEl ? parseInt(thumbsEl.dataset.thumbsSpaceBetween, 10) || 10 : 10;

  let thumbsSwiper = null;

  // 1. Initialize Thumbs Swiper
  if (thumbsEnabled && thumbsEl) {
    thumbsSwiper = new Swiper(thumbsEl, {
      slidesPerView: 'auto',
      spaceBetween: thumbsSpaceBetween,
      freeMode: true,
      watchSlidesProgress: true,
      loop: false
    });
    wrapper.thumbsSwiper = thumbsSwiper;
  }

  // 2. Initialize Main Swiper
  const mainPrev = wrapper.querySelector('.swiper-button-prev');
  const mainNext = wrapper.querySelector('.swiper-button-next');
  const mainPagination = wrapper.querySelector('.swiper-pagination');

  const mainConfig = {
    slidesPerView: 1,
    spaceBetween: spaceBetween,
    loop: loop,
    effect: effect,
    speed: speed,
    watchSlidesProgress: true,
    navigation: {
      nextEl: mainNext,
      prevEl: mainPrev,
    },
    pagination: {
      el: mainPagination,
      clickable: true,
    },
    on: {
      sliderMove: function() {
        wrapper.setAttribute('dragging', 'true');
      },
      touchEnd: function() {
        setTimeout(() => {
          wrapper.removeAttribute('dragging');
        }, 150);
      }
    }
  };

  if (autoplay) {
    mainConfig.autoplay = {
      delay: autoplayDelay,
      disableOnInteraction: false,
    };
  }

  if (thumbsSwiper) {
    mainConfig.thumbs = {
      swiper: thumbsSwiper,
    };
  }

  const mainSwiper = new Swiper(mainEl, mainConfig);
  wrapper.mainSwiper = mainSwiper;
};

// Initial initialization on load
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-media-swiper-wrapper').forEach(wrapper => {
    window.initProductSwiperGallery(wrapper);
  });
});

// Shopify Theme Editor reload support
document.addEventListener('shopify:section:load', (event) => {
  const wrapper = event.target.querySelector('.product-media-swiper-wrapper');
  if (wrapper) {
    window.initProductSwiperGallery(wrapper);
  }
});
